var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.navs),function(i){return _c('router-link',{key:i.name,staticClass:"tab",class:{ active: _vm.r === i.path },attrs:{"to":i.path}},[_vm._v(_vm._s(i.name))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }